import { api } from '@/lib/http'
import type { Account, Space } from '@/lib/types'

export interface MeResponse {
  account: Account
  spaces: Space[]
}

/** Account plus every space it belongs to, in one round trip. */
export function getMe(): Promise<MeResponse> {
  return api<MeResponse>('/api/account/me')
}

export function updateAlias(alias: string): Promise<{ alias: string }> {
  return api<{ alias: string }>('/api/account/me', { method: 'PATCH', body: { alias } })
}
